import { kBiConformedKeyLabels } from '@euler/app/components/message/widgets/bi-upload/functions/biUploadLabels';
import { biText } from '@euler/app/components/message/widgets/bi-visualization/functions/biText';
import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDatasetCatalog } from '@euler/model/bi/catalog';
import { Link2 } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiTag } from '../../components/ui/BiTag';
import { DetailSection } from './DetailSection';
import { biFieldKindText } from './functions/biFieldKindText';

/** The fields a query on the dataset can use, as the caller may use them. */
export const SchemaSection = memo(
  ({ catalog }: { catalog: BiDatasetCatalog }) => {
    const { rpx } = useResponsiveContext();
    return (
      <DetailSection title={`字段（${catalog.fields.length}）`}>
        <View>
          {catalog.fields.map((field, index) => (
            <View
              key={field.key}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: rpx(8),
                paddingVertical: rpx(8),
                borderTopWidth: index ? 1 : 0,
                borderTopColor: aiColors.border,
              }}
            >
              <Typography.Text
                size={rpx(13)}
                color={aiColors.foreground}
                style={{ flexGrow: 1, flexShrink: 1 }}
              >
                {biText(field.label)}
              </Typography.Text>
              <BiTag
                text={biFieldKindText(field)}
                color={aiColors.mutedForeground}
              />
              {catalog.primaryTime === field.key ? (
                <BiTag text="主时间" color={aiColors.violet} />
              ) : null}
              {field.conformedKey ? (
                <BiTag
                  text={kBiConformedKeyLabels[field.conformedKey]}
                  color={aiColors.amber}
                  icon={Link2}
                />
              ) : null}
            </View>
          ))}
        </View>
      </DetailSection>
    );
  },
);
